import './index.scss'
import { Fragment, useEffect, useRef, useState } from 'react'
import Author1Img from '@/assets/image/home/Author1.png'
import Author2Img from '@/assets/image/home/Author2.png'
import Author3Img from '@/assets/image/home/Author3.png'
import Author4Img from '@/assets/image/home/Author4.png'
import Author5Img from '@/assets/image/home/Author5.png'
import DisplayText from '../../../../components/DisplayText'

const PUBLISH_ROW_DELAY = 160

const articles = [
  {
    id: 1,
    tag: 'Agent-Native Banking',
    title: 'Autonomous capital requires a new banking stack.',
    desc: 'Authorization, solvency, and intent must be enforced before execution.',
    authors: ['Nova Wang', 'SJ Liang'],
    imgList: [Author1Img, Author2Img],
    link: '/blogDetail?slug=agent-native-banking',
  },
  {
    id: 2,
    tag: 'Frauds in AI Era',
    title: 'Approval does not guarantee execution.',
    desc: 'As agents act autonomously, correctness must be enforced before capital moves.',
    authors: ['SJ Liang', 'Nova Wang'],
    imgList: [Author2Img, Author1Img],
    link: '/blogDetail?slug=frauds-in-ai-era',
  },
  {
    id: 3,
    tag: 'Execution Verification',
    title: 'Fraud expands as systems become autonomous.',
    desc: 'Verification must extend from prompts to execution.',
    authors: ['Justin Cheng', 'Nova Wang', 'SJ Liang'],
    imgList: [Author3Img, Author2Img, Author1Img],
    link: '/blogDetail?slug=execution-verification',
  },
  {
    id: 4,
    tag: 'Privacy Is Neither Anonymity nor Secrecy:',
    title: 'Privacy is not secrecy.',
    desc: 'Selective disclosure is the primitive for institutional systems.',
    authors: ['Parth Gargava · Fidelity Labs', 'Canice Wu · Salesforce', 'SJ Liang', 'Justin Cheng'],
    imgList: [Author5Img, Author4Img, Author2Img, Author3Img],
    link: '/blogDetail?slug=selective-disclosure',
  },
]

const Publish = () => {
  const publishRef = useRef(null)
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    const current = publishRef.current

    if (!current) return undefined

    if (!('IntersectionObserver' in window)) {
      setIsVisible(true)
      return undefined
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true)
          observer.disconnect()
        }
      },
      { threshold: 0.16, rootMargin: '0px 0px -10% 0px' }
    )

    observer.observe(current)

    return () => observer.disconnect()
  }, [])

  return (
    <div ref={publishRef} className={`publish${isVisible ? ' publish--visible' : ''}`}>
      <div className="publish-inner">
        <div className="publish-header publish-reveal" style={{ '--publish-reveal-delay': '0ms' }}>
          <div className="publish-header-title">
            <DisplayText fullText="The ideas behind autonomous capital" />
          </div>
          <div className="publish-header-subtitle">
            Every system we build starts as a principle and ships as an enforced constraint.
          </div>
        </div>

        <div className="shaping-list">
          {articles.map((article, idx) => (
            <Fragment key={article.id}>
              {idx > 0 && <div className="shaping-row__divider" />}
              <article
                className="shaping-row shaping-row__body publish-reveal"
                style={{ '--publish-reveal-delay': `${180 + idx * PUBLISH_ROW_DELAY}ms` }}
              >
                <div className="shaping-row__left">
                  <span className="shaping-row__tag">{article.tag}</span>
                  <h3 className="shaping-row__title">{article.title}</h3>
                </div>

                <div className="shaping-row__desc">
                  <p>{article.desc}</p>
                  <a
                    className="shaping-row__read-link"
                    href={article.link}
                    rel="noreferrer"
                  >
                    <span className="shaping-row__read">→ Read More</span>
                  </a>
                </div>

                <div className="shaping-row__meta">
                  <div className="shaping-row__avatars">
                    {article.imgList.map((item, index) => (
                      <img
                        key={`${article.title}-avatar-${index}`}
                        className="shaping-author-avatar"
                        src={item}
                        alt=""
                        style={{ zIndex: article.imgList.length - index }}
                      />
                    ))}
                  </div>
                  <div className="shaping-row__authors">
                    {article.authors.map((author) => (
                      <span key={author}>{author}</span>
                    ))}
                  </div>
                </div>
              </article>
            </Fragment>
          ))}
        </div>

        <div className="publish-footer publish-reveal" style={{ '--publish-reveal-delay': '1260ms' }}>
          Research by the Vishwa team, with selected collaborators.
        </div>
      </div>
    </div>
  )
}

export default Publish
